export default "__VITE_ASSET__iJ_rKQvA__"